<script>
  export default {
    props: {
      color: {
        type: String,
        required: false,
        default: "var(--neutral-500)",
      },
    },
  };
</script>

<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7.5V4.5M7 7.5V4.5M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142
1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
